export const lockPrePack = (prePack, unlockedPrePacksMap) => () => unlockedPrePacksMap.delete(prePack.id);
//# sourceMappingURL=lockPrePack.js.map